import type { Action } from '../../action-creators';
import {
	SET_PROJECT_ACCESS_TYPE,
	FETCH_PROJECT_ACCESS_TYPES_SUCCESS,
	FETCH_PROJECT_ACCESS_TYPES_FAIL,
} from '../../constants';
import type { Ui } from '../../types';
import { FETCH_PROJECT_ACCESS_TYPES } from '../access-types/project-access-type';

export const defaultUiState = {
	isLoading: false,
	fetchDataError: false,
} as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: Ui = defaultUiState, action: Action): Ui => {
	switch (action.type) {
		case FETCH_PROJECT_ACCESS_TYPES:
			return { ...state, isLoading: true };
		case FETCH_PROJECT_ACCESS_TYPES_SUCCESS:
			return { ...state, isLoading: false };
		case SET_PROJECT_ACCESS_TYPE:
			if (
				// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
				action.payload.accessType &&
				(!state.selectedAccessType ||
					// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
					state.selectedAccessType.value !== action.payload.accessType.value)
			) {
				// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
				return { ...state, selectedAccessType: action.payload.accessType };
			}

			return state;
		case FETCH_PROJECT_ACCESS_TYPES_FAIL:
			return { ...state, isLoading: false, fetchDataError: true };
		default:
			return state;
	}
};
